import { IComponentConfig } from "@/app/@types/base-component";
import { ReactiveComponent } from "./base-component";
import { ref, Ref } from "vue";

export type InstallationItemConfig = IComponentConfig & {
    partitionName: string;
    parentId: string;
    minPrice: number;
};

export class InstallationItem extends ReactiveComponent {
    partitionName: Ref<string>;
    parentId: Ref<string>;
    minPrice: Ref<number>;

    constructor(config: InstallationItemConfig) {
        super({ ...config, type: "installation-item" });

        this.partitionName = ref(config.partitionName || "");
        this.minPrice = ref(config.minPrice || 0);
        this.parentId = ref(config.parentId || "");
    }
}
